module.exports = __webpack_public_path__ + "img/banner-home.6ed85e38.png";